export const isImage = (isFile, type, filename) =>
  (isFile &&
    (type === 'image/png' ||
      type === 'image/jpg' ||
      type === 'image/jpeg' ||
      type === '.png' ||
      type === '.jpg' ||
      type === '.jpeg')) ||
  type === '.webp' ||
  filename.endsWith('.png') ||
  filename.endsWith('.jpg') ||
  filename.endsWith('.jpeg') ||
  filename.endsWith('.webp')

export const isXml = (isFile, type, filename) =>
  (isFile && (type === 'image/png' || type === 'image/jpg' || type === 'image/jpeg')) ||
  filename.endsWith('.png') ||
  filename.endsWith('.jpg') ||
  filename.endsWith('.jpeg')

export const getFileExtension = (url) => url.split(/#|\?/)[0].split('.').pop().trim()

export const getFileIcon = (file) => {
  let fileName = file
  let type = ''

  const isFile = typeof file !== 'string'

  if (isFile) {
    fileName = file.preview
    type = file.type
  }
  let icon = '/assets/icons/file-any.svg'

  if (isImage(isFile, type, fileName)) {
    return fileName
  } else if ((isFile && (type === 'text/xml' || type === '.xml')) || fileName.endsWith('.xml')) {
    icon = '/assets/icons/file-xml.svg'
  } else if (
    (isFile && (type === 'text/txt' || type === 'text/plain' || type === '.txt')) ||
    fileName.endsWith('.txt')
  ) {
    icon = '/assets/icons/file-txt.svg'
  } else if (
    (isFile && (type === 'application/pdf' || type === '.pdf')) ||
    fileName.endsWith('.pdf')
  ) {
    icon = '/assets/icons/file-pdf.svg'
  } else if (
    (isFile &&
      (type === 'application/msword' ||
        type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        type === '.doc' ||
        type === '.docx')) ||
    fileName.endsWith('.doc') ||
    fileName.endsWith('.docx')
  ) {
    icon = '/assets/icons/file-doc.svg'
  } else if (
    (isFile &&
      (type === 'application/vnd.ms-excel' ||
        type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        type === '.xls' ||
        type === '.xlsx')) ||
    fileName.endsWith('.xls') ||
    fileName.endsWith('.xlsx')
  ) {
    icon = '/assets/icons/file-xls.svg'
  } else if ((isFile && (type === 'text/csv' || type === '.csv')) || fileName.endsWith('.csv')) {
    icon = '/assets/icons/file-csv.svg'
  }

  return icon
}

export function cacheImages(imageUrls) {
  return Promise.all(
    imageUrls.map(
      (url) =>
        new Promise((resolve, reject) => {
          const img = new Image()
          img.src = url
          img.onload = resolve
          img.onerror = reject
        }),
    ),
  )
}

export function downloadFileByUrl(url) {
  const link = document.createElement('a')
  link.href = String(url || '')
  link.target = '_blank'
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
